module.exports = __webpack_public_path__ + "img/gigwidog5.1267c55b.jpg";